import {
  registerDashboardWidget,
  setDashboardWidgetLayout,
} from "@vendure/admin-ui/core";
export default [
  registerDashboardWidget("metrics", {
    title: "common.metrics",
    supportedWidths: [4, 6, 8, 12],
    loadComponent: () =>
      import("./metrics-widget").then((m) => m.MetricsWidgetComponent),
  }),
  setDashboardWidgetLayout([{ id: "metrics", width: 12 }]),
];
